/**
 * package: com.inq.ui
 * class: Screen
 * @extends com.inq.ui.Container 
 * @constructor
 */
com.inq.ui.Screen = function() {
	com.inq.ui.Container.call(this);
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.Screen, "com.inq.ui.Screen");
/** @type {com.inq.ui.Screen} */
com.inq.ui.Screen.prototype.__class__ = com.inq.ui.Screen;
